import { ReactNode } from "react"
import Sensors from "./Sensors/Sensors"
import { IDeviceConfig } from "../../APIRequests/APIPut"
import Timers from "./Timers/Timers"
import DeviceType from "../DeviceType"

interface Props {
  deviceConfig: IDeviceConfig
  saveConfig: (config: IDeviceConfig) => void
  configSchema: { [propName: string]: any } | undefined
}

export default function LiteQDeviceV2({
  deviceConfig,
  saveConfig,
  configSchema,
}: Props) {
  let tabsConfig = new Map<string, ReactNode>()

  tabsConfig
    .set(
      "Sensors",
      <Sensors
        deviceConfig={deviceConfig}
        saveConfig={saveConfig}
        configSchema={configSchema}
      />
    )
    .set(
      "Timers",
      <Timers
        deviceConfig={deviceConfig}
        saveConfig={saveConfig}
        configSchema={configSchema}
      />
    )

  return <DeviceType tabsConfig={tabsConfig} />
}
